export enum Radii {
	Small = '4px',
	Default = '8px',
	Medium = '24px',
	Big = '100px',
	Circle = '100%'
}
